import cn from "classnames";
import { NavLink } from "react-router-dom";
import { IKBPageSmall } from "src/widgets/KnowledgeBase/types";

import styles from "./DocLink.module.scss";

interface DocLinkProps {
  basePath: string;
  sectionSlug: string;
  doc: IKBPageSmall;
  onClick?: () => void;
}

export const DocLink = ({
  basePath,
  sectionSlug,
  doc,
  onClick,
}: DocLinkProps) => {
  return (
    <div className={styles.leaf}>
      <NavLink
        to={`${basePath}/${sectionSlug}/${doc.slug}`}
        className={({ isActive }) =>
          cn(
            styles.linkRouter,
            isActive ? styles.activeLink : styles.defaultLink,
          )
        }
        onClick={onClick}
      >
        {doc.title}
      </NavLink>
    </div>
  );
};
